<template>
  <router-view />
</template>

<script>
export default {
  name: 'DomainsIndex'
}
</script>
